import React from "react";
import { useSelector } from "react-redux";
import {
  Button,
  Typography,
  Box,
  Grid,
  useMediaQuery,
  IconButton,
} from "@material-ui/core";
import AddCircleRoundedIcon from "@material-ui/icons/AddCircleRounded";
import userActions from "./actions";
import { UserRole } from "./constants";
import PropTypes from "prop-types";




const Header = ({ children }) => {
  const { role } = useSelector((state) => state.auth);
  const { openCreateDialog } = userActions();
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  return (
    <Box my={2}>
      <Grid
        container
        justify={matches ? "space-between" : "center"}
        alignItems="center"
      >
        {!matches && (role === UserRole.SUPERADMIN || role === UserRole.ADMIN) && (
          <IconButton
            size="medium"
            variant="contained"
            color="primary"
            onClick={() => openCreateDialog()}
          >
            <AddCircleRoundedIcon fontSize="large" />
          </IconButton>
        )}
        <Typography variant="h6" style={{fontSize: '18px', fontWeight: 'bold', fontColor: '#323232'}}>{children}</Typography>

        {matches && (role === UserRole.SUPERADMIN || role === UserRole.ADMIN) && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => openCreateDialog()}
          >
            Invite Member to CuRVE
          </Button>
        )}
      </Grid>
    </Box>
  );
};

Header.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Header;
